import HeadlessSpEditor from '@/features/shared/component/HeadlessSpEditor'
import { WorkspaceLayout } from '@/features/workspace'
import ShotListMainContent from '../components/ShotListMainContent'
import SlOptionBar from '../components/SlOptionBar'
import SlSidebar from '../components/SlSidebar'
import { useNavigate, useParams } from 'react-router-dom'
import { useScreenplayQuery } from '@/features/screenplay/queries/screenplay.queries'
import { FileText } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'

import { NoScreenplayState } from '@/features/shared/component/NoScreenplayState'

const ShotListPage = () => {
    const { project_id } = useParams<{ project_id: string }>()
    const navigate = useNavigate()
    const { data: screenplay, isLoading } = useScreenplayQuery(project_id, 'master')

    const hasScreenplayContent = screenplay && screenplay.content && screenplay.content.length > 0

    return (
        <WorkspaceLayout
            SidebarComponent={<SlSidebar />}
            optionBar={<SlOptionBar />}
        >
            {isLoading ? (
                <div className="flex h-full w-full items-center justify-center bg-background">
                    <p className="animate-pulse font-medium text-muted-foreground">Loading screenplay...</p>
                </div>
            ) : !hasScreenplayContent ? (
                <NoScreenplayState moduleName="Shot lists" />
            ) : (
                <>
                    <HeadlessSpEditor />
                    <ShotListMainContent />
                </>
            )}
        </WorkspaceLayout>
    )
}

export default ShotListPage
